import ReactDOM from "react-dom/client";
import App from "./App";
import "./i18n";
import "./styles/tailwind.scss";

const target = document.querySelector("#app");
const root = ReactDOM.createRoot(target);
root.render(<App />);
